import 'styles/page/futureworth.page.css'
import React, { useState } from 'react'
import Navigation from 'components/navigation/navigation'
import ForecastPanel from './panels/forecast.panel'
import PortfolioPanel from './panels/portfolio.panel'
import EditPanel from 'components/edit/edit.panel'
import BottomDrawer from 'components/drawers/bottom.drawer'
import LoadingScreen from 'components/loading.screen'
import { useData } from 'context/data.context'

const FutureWorth = () => {
  const { loadingUserData, dataError, refreshData } = useData();
  // Modal state management
  const [isEditing, setIsEditing] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [editingType, setEditingType] = useState(null); // 'Assets' or 'Liabilities'

  const editEntry = (item, type) => {
    setIsEditing(true);
    setEditingItem(item);
    setEditingType(type);
  };

  const cancelEntry = () => {
    setIsEditing(false);
    setEditingItem(null);
    setEditingType(null);
  };

  if (loadingUserData) return <LoadingScreen />;
  if (dataError) return <LoadingScreen error={dataError} onRetry={refreshData} />;

  return (
    <div className='FutureworthPage'>
      <Navigation />

      <div className="Container">
        <ForecastPanel />
        <PortfolioPanel onItemClick={editEntry} />
      </div>

      {/* EDITING MODAL */}
      {isEditing && (
        <BottomDrawer onCancel={cancelEntry}>
          <EditPanel
            isAsset={editingType === 'Assets'}
            isNew={false}
            item={editingItem}
            onCancelHandler={cancelEntry}
          />
        </BottomDrawer>
      )}
    </div>
  )
}

export default FutureWorth
